import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Move to .env in production: REACT_APP_FIREBASE_API_KEY, etc.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAYpxdr7reobzb4kTYSQAjC-uMGb-Z7WXY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "glow-28657.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "glow-28657",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "glow-28657.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "157510076723",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:157510076723:web:a7fcd497f347b088ef9646",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-DGNEPQDL8M",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
